import { render, staticRenderFns } from "./FilterLabel.vue?vue&type=template&id=40b8f2d5&scoped=true&functional=true"
import script from "./FilterLabel.vue?vue&type=script&lang=js"
export * from "./FilterLabel.vue?vue&type=script&lang=js"
import style0 from "./FilterLabel.vue?vue&type=style&index=0&id=40b8f2d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "40b8f2d5",
  null
  
)

export default component.exports